import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const ExamGroupService = sdk.getService('ExamGroupService');

export const useWidgetNextExamGroups = () => {
  const queryKey = ['exam-groups', 'widget', 'next-exam-groups'];
  const { isLoading, data } = useQuery({
    queryKey,
    queryFn: () => ExamGroupService.getWidgetNextExamGroups()
  });

  return {
    examGroups: data,
    isLoading
  };
};
